import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Stack, Typography, styled, useTheme } from '@mui/material';
import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import HeaderLayout from '../../../components/Layout/Header/HeaderLayout';
import {
  BodyContainer,
  IconsRiskProfile,
  ProfileActionsBox,
  ProfileImageBox,
  ProfileInfoContainer,
  ProfileWrapper,
  RiskOptionsStack,
  TitleContainer,
  TitleStepeBox,
  TitleText,
} from '../../../components/Layout/InternalLayout/StyledComponentsProfile';
import { TitleStepe } from '../../../components/Layout/InternalLayout/TitleStepe';
import StepperProgress from '../../../components/profile/StepperProgress';
import Spinner from '../../../components/Spinner';
import useGetQuestions from '../../../hooks/useGetQuestions';
import { updateQuestions } from '../../../redux/questions';

const SelectorTimeInvertio = styled(Stack)(({ theme }) => ({
  background: theme.palette.white.main,
  backdropFilter: 'blur(48px)',
  WebkitBackdropFilter: 'blur(48px)',
  boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
  borderRadius: '8px',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  width: '100%',
  height: '117px',
  justifyContent: 'flex-start',
  alignItems: 'center',
  boxSizing: 'border-box',
  color: theme.palette.primary.darkBlue,
  transition: 'ease-in-out',
  transitionDuration: '100ms',
  cursor: 'pointer',
  '&:hover': {
    background: theme.palette.primary.profileGradient,
    backdropFilter: 'blur(48px)',
    WebkitBackdropFilter: 'blur(48px)',
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
    borderRadius: '8px',
    color: theme.palette.white.main,
    transition: 'ease-in-out',
    transitionDuration: '100ms',
  },
}));

const TextTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  flex: '1',
  margin: '0px',
  color: 'inherit',
  fontWeight: theme.typography.littleText.fontWeight,
  fontSize: theme.typography.description.fontSize,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.returnText.fontSize,
  },
}));

export const StepperButton = styled(Button)(({ theme, disabled }) => ({
  borderRadius: '4px',
  border: 'none',
  textTransform: 'none',
  fontSize: theme.typography.button.fontSize,
  fontWeight: theme.typography.button.fontWeight,
  backgroundColor: 'transparent',
  color: disabled ? theme.palette.textLight.main : theme.palette.secondary.text,
  ':hover': {
    border: 'none',
    backgroundColor: theme.palette.white.main,
  },
}));

const ProfileQuestions = ({}) => {
  const selectedContent = '';
  const userProfileContent = 'nada';
  const theme = useTheme();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [questions, setQuestions] = React.useState([]);
  const [foreign, setForeign] = useState(false);
  const [stepper, setstepper] = useState(0);
  const [userAnswers, setUserAnswers] = useState({});
  const [steppercolor, setSteppercolor] = useState({
    comp0: true,
    comp1: false,
    comp2: false,
    comp3: false,
    comp4: false,
    comp5: false,
    comp6: false,
    comp7: false,
    comp8: false,
  });
  const { user } = useSelector(state => state.auth);

  const [doGetQuestions, { data, error: errorGetQuestions, loading: loadingGetQuestions }] =
    useGetQuestions();

  const successGetQuestions = data?.getQuestions || [];

  const isNextButtonDisabled = !userAnswers[stepper]?.answerId;

  useEffect(() => {
    doGetQuestions();
  }, []);

  useEffect(() => {
    if (errorGetQuestions && !loadingGetQuestions) {
      message.error('Ha ocurrido un error al obtener las preguntas');
    }
  }, [errorGetQuestions, loadingGetQuestions]);

  useEffect(() => {
    if (successGetQuestions && !loadingGetQuestions) {
      setQuestions(successGetQuestions);
    }
  }, [successGetQuestions, loadingGetQuestions]);

  const Handleback = () => {
    setstepper(stepper - 1);
    setSteppercolor({
      ...steppercolor,
      [`comp${stepper}`]: false,
    });
  };
  //Avanza a la sig pregunta si hay una respuesta válida seleccionada, envía las respuestas y navega a los resultados
  const HandleNext = () => {
    if (isNextButtonDisabled) {
      return; // verifico si answerId está vacío o nulo será true y no realiza ninguna acción
    }
    if (stepper < questions.length - 1) {
      setstepper(stepper + 1);
      // Limpiar el color seleccionado del paso anterior
      const previousStep = `comp${stepper}`;
      setSteppercolor({
        ...steppercolor,
        [previousStep]: false,
      });
    } else {
      // Si es la última pregunta, actualizar respuestas y navegar a la página de resultados
      dispatch(updateQuestions(userAnswers));
      navigate('/questionsresults');
    }
  };

  const Handlestep = data => {
    if (stepper === questions.length - 1) {
      dispatch(updateQuestions(data));
      navigate('/questionsresults');
      return;
    }
    // Si el dispositivo es móvil, no avanzar automáticamente al siguiente paso
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      return;
    }
    // Avanzar al siguiente paso si no es la última pregunta y no es un dispositivo móvil
    setstepper(stepper + 1);
  };
  const changeCurrentAnswer = (questionId, answerId) => {
    const data = {
      ...userAnswers,
      [stepper]: {
        questionId,
        answerId,
      },
    };
    setUserAnswers(data);
    Handlestep(data);
  };

  if (questions.length === 0 || loadingGetQuestions) {
    return <Spinner />;
  }

  return (
    <>
      <HeaderLayout showLogoOnly />
      <ProfileWrapper>
        <TitleContainer>
          <TitleText>Mi Perfil de inversiones</TitleText>
        </TitleContainer>

        <BodyContainer>
          <ProfileInfoContainer>
            <ProfileImageBox>
              <IconsRiskProfile
                sx={{
                  width: 'clamp(5.1875rem, 1.4375rem + 16vw, 10.4375rem)',
                }}
                src={'/assets/images/perfil-noDefined.svg'}
              />
            </ProfileImageBox>

            <TitleStepeBox sx={{ mt: { xs: '102x', md: '0px' } }}>
              <TitleStepe user={user} description={questions[stepper].question} />
            </TitleStepeBox>
          </ProfileInfoContainer>

          <ProfileActionsBox>
            <RiskOptionsStack sx={{ mt: { xs: '-28px', md: '0px' } }}>
              <Box
                sx={{
                  position: 'sticky',
                  top: '16px',
                  height: '20px',
                  flexShrink: 1,
                  mx: '8px',
                  zIndex: 1,
                }}>
                <StepperProgress stepper={stepper} stepperLong={successGetQuestions} />
              </Box>

              <Stack
                sx={{
                  flex: 1,
                  overflowY: 'auto',
                  padding: '16px 0',
                  gap: 2,
                }}>
                {questions[stepper].answers.map((answer, index) => {
                  return (
                    <SelectorTimeInvertio
                      key={index}
                      onClick={() =>
                        changeCurrentAnswer(questions[stepper].questionId, answer.answerId)
                      }
                      sx={{
                        padding: '30px',
                        width: 'calc(100% - 16px)',
                        mx: '8px',
                      }}>
                      <TextTitle>{answer.answer}</TextTitle>
                    </SelectorTimeInvertio>
                  );
                })}
              </Stack>

              <Stack sx={{ alignItems: 'center' }}>
                {stepper >= 1 && (
                  <StepperButton onClick={Handleback} startIcon={<ArrowBackIcon />}>
                    Volver
                  </StepperButton>
                )}

                {stepper < questions.length - 1 && (
                  <StepperButton
                    disabled={isNextButtonDisabled}
                    onClick={HandleNext}
                    endIcon={<ArrowForwardIcon />}
                    sx={{
                      display: { md: 'none', xs: 'flex' },
                      color: isNextButtonDisabled
                        ? theme.palette.textLight.main
                        : theme.palette.secondary.text,
                    }}>
                    Siguiente
                  </StepperButton>
                )}
              </Stack>
            </RiskOptionsStack>
          </ProfileActionsBox>
        </BodyContainer>
      </ProfileWrapper>
    </>
  );
};

export default ProfileQuestions;
